// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2X6Hn","col":"styles_col__6butQ"};